import Contact from '../Models/Contact';
import DataGridRequest from './DataGridRequest';
export class ContactsRequest extends DataGridRequest<Contact> {
    Url = '/subscribers/contacts/api';
}
